import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CeIconComponent } from '../ce-icon/ce-icon.component';
import { CeLinkButtonComponent } from '../ce-link-button/ce-link-button.component';
import { Icons } from '../ce-icon/ICONLIB';

@Component({
    selector: 'ce-empty-state',
    imports: [CommonModule, CeIconComponent, CeLinkButtonComponent],
    encapsulation: ViewEncapsulation.None,
    templateUrl: './ce-empty-state.component.html',
    styleUrl: './ce-empty-state.component.scss'
})
export class CeEmptyStateComponent implements OnInit {
    @Input({ required: true }) type?: 'not-found' | 'unauthorized' | 'notification' | 'empty' | 'charging-station' | 'no-data-xs' | 'empty-table-xs' | 'error-xs';
    @Input() size?: 'xs' | 'md' | 'lg' = 'lg';
    @Input() actionRefresh?: boolean;
    @Input() actionHref?: string;
    @Input() actionLabel?: string;
    icon?: keyof Icons;

    ngOnInit(): void {
        if (this.type === 'not-found') {
            this.icon = 'not-found-filled';
        } else if (this.type === 'unauthorized') {
            this.icon = 'locked-filled';
        } else if (this.type === 'notification') {
            this.icon = 'notification-filled';
        } else if (this.type === 'empty') {
            this.icon = 'empty-box-filled';
        } else if (this.type === 'charging-station') {
            this.icon = 'charging-station-filled';
        } else if (this.type === 'no-data-xs') {
            this.icon = 'no-data';
        } else if (this.type === 'empty-table-xs') {
            this.icon = 'empty-table';
        } else if (this.type === 'error-xs') {
            this.icon = 'empty-state-error';
        }
    }

    refreshPage(): void {
        window.location.reload();
    }
}
